import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {TariffElementService} from '../../services/tariff-element.service';
import {TariffElementActions} from './tariff-element.actions';
import {catchError, map, tap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {DictionaryItem} from '../../models/dictionary.model';
import {NotificationService} from '../../services/notification.service';

export interface TariffElementStateModel {
    uploadErrors: any[];
    importDate: string;
}

const STATE_NAME = 'tariffElements';

@State<TariffElementStateModel>({
    name: STATE_NAME,
    defaults: {
        uploadErrors: [],
        importDate: null,
    }
})


@Injectable()
export class TariffElementState {
    constructor(
        private tariffElementService: TariffElementService,
        private notificationService: NotificationService,
    ) {
    }

    @Selector()
    static uploadErrors(store) {
        return store.uploadErrors;
    }

    @Selector()
    static importDate(store) {
        return store.importDate;
    }

    @Selector()
    static status(store) {
        return store.status;
    }

    @Action(TariffElementActions.UploadFile)
    uploadFile(ctx: StateContext<TariffElementStateModel>, {hash}: TariffElementActions.UploadFile) {
        return this.tariffElementService.uploadFile(hash)
            .pipe(
                tap(() => {
                    this.notificationService.success('LABELS.UPLOAD_SUCCESS');
                    ctx.dispatch(new TariffElementActions.ImportDate());
                    ctx.patchState({
                        uploadErrors: []
                    });
                }),
                catchError((res) => {
                    ctx.patchState({
                        uploadErrors: res?.error?.map(
                            (item: DictionaryItem) => ({
                                place: item?.description.split(';')[0],
                                description: item?.description.split(';')[1]
                            })
                        ),
                    });
                    return EMPTY;
                })
            );
    }

    @Action(TariffElementActions.DownloadFile)
    downloadFile() {
        return this.tariffElementService.downloadFile();
    }

    @Action(TariffElementActions.ImportDate)
    importDate(ctx: StateContext<TariffElementStateModel>) {
        return this.tariffElementService.getDate().pipe(
            map((importDate) => {
                ctx.patchState({
                    importDate,
                });
                return importDate;
            })
        );
    }
}
